import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { TeamSearchResultAvatar } from "./TeamSearchResultAvatar";
export const TeamSearchResultView = ({ teamSearchResult, variant = "h6", }) => {
    return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(TeamSearchResultAvatar, { teamSearchResult: teamSearchResult }), _jsx(Typography, { variant: variant, children: _jsx(TeamSearchResultDisplayNameLink, { teamSearchResult: teamSearchResult }) })] }));
};
const TeamSearchResultDisplayNameLink = ({ teamSearchResult, }) => {
    const displayName = teamSearchResult.name;
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/teams/${teamSearchResult.id}/`, children: displayName }, teamSearchResult.id));
};
